<template>
  <Modal
    persistent
    :title="$t('modals.two_factor_verify_code_modal.title')"
    @hide="onDialogHide"
  >
    <TwoFactorVerifyCodeTemplate
      v-model:code="code"
      :carrier="carrier"
      :error="error"
      :uri="uri"
    />

    <template #buttons>
      <BaseButton
        :label="$t('global.cancel')"
        new-design
        @click="onCancelClick"
      />
      <BaseButton
        color="primary"
        :label="$t('global.ok')"
        new-design
        @click="onOKClick"
      />
    </template>
  </Modal>
</template>

<script>
import BaseButton from "shared/components/base/BaseButton.vue";
import Modal from "shared/components/core/modals/Modal.vue";
import TwoFactorVerifyCodeTemplate from "shared/components/user/TwoFactorVerifyCodeTemplate.vue";

export default {
  name: "TwoFactorVerifyCodeModal",
  components: {
    Modal,
    BaseButton,
    TwoFactorVerifyCodeTemplate,
  },
  props: {
    uri: {
      type: String,
      default: "",
    },
    carrier: {
      type: String,
      required: true,
    },
    error: {
      type: Error,
      default: null,
    },
  },
  emits: ["hide", "ok"],
  data() {
    return {
      code: "",
    };
  },
  methods: {
    hide() {
      this.$modals.close("TwoFactorVerifyCodeModal");
    },
    onDialogHide() {
      this.$emit("hide");
    },
    onOKClick() {
      this.$emit("ok", this.code);
      this.hide();
    },
    onCancelClick() {
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.mfacode-input) {
  background-color: $silver-white !important;
  font-size: 1.5em;
  padding: 10px;
}
</style>
